import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "../../Style/Modules/singleGstDetails.module.css";
import "../../Style/Theme/index.css";

import {
  constant,
  decryptData,
  loggerStore,
  multiDecryption,
} from "../../utils/utils";
import useSelector from "../../store/selector";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import configData from "../../Config";
import {
  Alert,
  AlertTitle,
  Box,
  Chip,
  Container,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Header from "../common/Header";
import SubmitButton from "../common/SubmitButton";
import { apis } from "../../services/apiService";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import AlertPopup from "../common/AlertPopup";

const SingleGSTDetails = () => {
  const { setRecoilVal, getRecoilVal } = useSelector();
  let location = useLocation();
  const navigate = useNavigate();
  const [gstDetailFromLocation, setGSTDetailFromLocation] = useState();
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");

  const checkRecoilData = async () => {
    let getPreGstDatafromRecoil = getRecoilVal(constant.atomsName.GST_DETAILS);
    let singledecrypteddata = await decryptData(
      getPreGstDatafromRecoil[location?.state?.gstin.trim()]
    );
    setGSTDetailFromLocation(JSON.parse(singledecrypteddata));
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    if (location?.state?.gstin.trim() !== "") {
      try {
        setLoading(true);
        const reqData = {
          aid: location.state.AppId,
          gst: location?.state?.gstin.trim(),
          show_details: false,
        };

        let resp = await apis.postApi(
          configData.API_URL + "GST/GSTDetailed",
          reqData
        );
        let result = await resp.json();
        if (resp.status === 200) {
          let data = {
            AppId: location.state.AppId,
            gstin: location?.state?.gstin.trim(),
            anchor: location.state.anchor,
            program: location.state.program,
            source: location.state.source,
          };
          navigate("/upload-gst", { state: data });
          loggerStore(
            location?.state?.AppId,
            `GST AddGST API response for success = ${JSON.stringify(result)}`,
            "Information"
          );
        }
        setLoading(false);
      } catch (error) {
        const errorResult = JSON.parse(error?.message);
        setLoading(false);
        setFinalErr(errorResult?.statusMessage);
        loggerStore(
          location?.state?.AppId,
          `GST AddGST API response for catch if show_Details:false = ${JSON.stringify(
            error
          )}`,
          "Information"
        );
      }
    }
  };

  useEffect(() => {
    checkRecoilData();
  }, [location?.state?.gstin]);

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Box
          component="form"
          noValidate
          id="singleGSTDetails"
          // onSubmit={handleSubmit}
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <Header showBar={true} step={4} />
          <Box component="GSTDetails" className={styles.singleGstDetailsBox}>
            {/* <Box className={styles.singleGstDetailsBox1}>
              <Stack direction="row" spacing={2}>
                <Avatar
                  alt="UserPhoto"
                  src={`data:image/png;base64,${gstDetailFromLocation?.result?.aadharPhoto}`}
                  sx={{
                    width: 100,
                    height: 100,
                    border: "4px solid #50E0FF",
                  }}
                />
              </Stack>
              <Typography className={styles.singleGstDetailsTypo}>
                {gstDetailFromLocation?.result?.contacted?.name}
              </Typography>
            </Box> */}
            <Box className={styles.singleGstDetailsBox2}>
              <Divider className="dividerbg_Th">
                <Chip
                  className={`${styles.singleGstDetailsPaper}`}
                  icon={<AccountCircleIcon />}
                  sx={{ fontWeight: "bold" }}
                  label="USER DETAILS"
                />
              </Divider>
              <Paper className={styles.singleGstDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Name</Typography>
                <Typography>
                  {gstDetailFromLocation?.result?.contacted?.name}
                </Typography>
              </Paper>
              <Paper className={styles.singleGstDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Email</Typography>
                <Typography>
                  {gstDetailFromLocation?.result?.contacted?.email}
                </Typography>
              </Paper>
              <Paper className={styles.singleGstDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Mobile</Typography>
                <Typography>
                  {gstDetailFromLocation?.result?.contacted?.mobNum}
                </Typography>
              </Paper>
            </Box>
            <Box className={styles.singleGstDetailsBox2}>
              <Divider className="dividerbg_Th">
                <Chip
                  className={`${styles.singleGstDetailsPaper}`}
                  icon={<BusinessCenterIcon />}
                  sx={{ fontWeight: "bold" }}
                  label="BUSINESS DETAILS"
                />
              </Divider>
              <Paper className={styles.singleGstDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>GST Number</Typography>
                <Typography>{gstDetailFromLocation?.result?.gstin}</Typography>
              </Paper>
              <Paper className={styles.singleGstDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Nature of business
                </Typography>
                <Typography>{gstDetailFromLocation?.result?.nba[0]}</Typography>
              </Paper>
              <Paper className={styles.singleGstDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Registration date under GST
                </Typography>
                <Typography>{gstDetailFromLocation?.result?.rgdt}</Typography>
              </Paper>
              <Paper className={styles.singleGstDetailsPaper}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Constitution of Business
                </Typography>
                <Typography>{gstDetailFromLocation?.result?.ctb}</Typography>
              </Paper>
              <Paper className={styles.singleGstDetailsPaper1}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Bussiness Name
                </Typography>
                <Typography>
                  {gstDetailFromLocation?.result?.tradeNam}
                </Typography>
              </Paper>
              <Paper className={styles.singleGstDetailsPaper1}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Bussiness Address
                </Typography>
                <Typography>
                  {gstDetailFromLocation?.result?.pradr?.adr}
                </Typography>
              </Paper>
              <Paper
                sx={{
                  mt: "5px",
                  p: 1,
                  mb: 13,
                }}
              >
                <Typography sx={{ fontWeight: "bold" }}>
                  State Jurisdiction
                </Typography>
                <Typography>{gstDetailFromLocation?.result?.stj}</Typography>
              </Paper>
            </Box>
          </Box>
          <SubmitButton hasNote="No" />
        </Box>
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
        {finalErr && (
          <Backdrop ax="center">
            <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
          </Backdrop>
        )}
      </Container>
    </>
  );
};

export default SingleGSTDetails;
